import { createContext } from "react";
import { toast } from "react-toastify";

const ToastContext = createContext({ toast });

// export const ToastProvider = ({ children }) => {
//     return (
//         <ToastContext.Provider value={{ toast }}>
//             {children}
//         </ToastContext.Provider>
//     );
// };

export default ToastContext;
